export default __webpack_public_path__ + "static/media/farming.6796e617.svg";